<template>
  <div>
    <v-text-field
      v-model="inputValue"
      outlined
      dense
      :disabled="disabled"
      :style="textFieldStyle"
      class="format-box"
      :type="number ? 'number' : 'text'"
      :rules="rules"
      :error-messages="errorMessages"
      validate-on-blur
      @blur="onBlur"
      @input="onInput"
    />
    <p
      v-if="errorMessages.length > 0"
      class="error--text"
    >
      {{ errorMessages[0] }}
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "textfield",
})
export default class Textfield extends Vue {
  @Prop() public value!: string;
  @Prop() public number!: boolean;
  @Prop({ default: false }) public disabled!: boolean;
  @Prop({ default: () => [] }) public rules!: Array<(v: any) => boolean | string>;

  public errorMessages: string[] = [];

  get textFieldStyle() {
    return {
      borderRadius: "8px",
      maxWidth: this.number ? "250px" : "250px",
      minWidth: this.number ? "250px" : "250px",
    };
  }

  get inputValue() {
    return this.value || "";
  }

  set inputValue(value: string) {
    this.$emit("input", value);
  }

  onInput(value: any) {
    this.validateInput(value);
  }

  onBlur() {
    this.$emit("blur");
    this.validateInput(this.inputValue);
  }

  public validateInput(value: any) {
    this.errorMessages = [];
    for (const rule of this.rules) {
      const result = rule(value);
      if (result !== true) {
        this.errorMessages.push(result as string); //Wut???
        break; // Show only first error message
      }
    }
  }

  mounted() {
    // Initial validation
    this.$nextTick(() => {
      this.validateInput(this.inputValue);
    });
  }
}
</script>
